export const Text = 'Text';
export const Icon = 'Icon';
export const IconButton = 'IconButton';
export const Image = 'Image';
export const Shapes = 'Shapes';
export const Line = 'Line';
export const Progress = 'Progress';
export const Spacer = 'Spacer';
export const Card = 'Card';
export const BoundingBox = 'BoundingBox';
export const Video = 'Video';
export const Audio = 'Audio';
export const Button = 'Button';
export const TextArea = 'TextArea';
export const DropDown = 'DropDown';
export const Alert = 'Alert';
export const TextInput = 'TextInput';
export const FileInput = 'FileInput';
export const RadioButton = 'RadioButton';
export const CheckBox = 'CheckBox';
export const DateAndTime = 'DateAndTime';
export const Chip = 'Chip';
export const Link = 'Link';
export const MenuButton = 'MenuButton';
export const Tabs = 'Tabs';
export const Container = 'Container';
export const FormContainer = 'FormContainer';
export const Div = 'Div';
export const ModuleChatbot = 'ModuleChatbot';
export const Popup = 'Popup';
export const ImageCard = 'ImageCard';
export const Section = 'Section';
export const Row = 'Row';
export const Col = 'Col';
export const Grid = 'Grid';
export const Iframe = 'Iframe';
export const Toggle = 'Toggle';
export const MultiLineInputText = 'MultiLineInputText';
export const MultiSelect = 'MultiSelect';
export const SingleSelect = 'SingleSelect';
export const Password = 'Password';
export const Url = 'Url';
export const Email = 'Email';
export const InputNumber = 'InputNumber';
export const Repeator = 'Repeator';
export const CurrencyInput = 'CurrencyInput';
export const TimePicker = 'TimePicker';
export const DatePicker = 'DatePicker';
export const Carousel = 'Carousel';
export const GoogleMap = 'GoogleMap';
export const Ratings = 'Ratings';
export const Popover = 'Popover';
export const CustomisedAccordion = 'CustomisedAccordion';
export const Conversation = 'Conversation';
export const PlaceAutoComplete = 'PlaceAutoComplete';
// export const PhoneNumberInput = 'PhoneNumberInput';
export const InputPhone = 'InputPhone';
export const Table = 'Table';
export const FloatingBox = 'FloatingBox';
export const TextWidgetVersion = 'v2.0';
export const HiddenwidgetEyeIcon = 'icon-ico_eye-hide';
export const SlideBlock = 'SlideBlock';
export const SlideBlockShow = 'slideBlockShow';
export const SlideBlockClose = 'slideBlockClose';
export const OverlayBackground='overlayBackground';
export const ShowSlideBlock='Show SlideBlock';
export const CloseSlideBlock='Close SlideBlock';  
export const PropValue='propValue';
export const SlideBlockZindex='1045';
export const SlideBlockCloseButtonZindex='1050';
export const TranslateLanguage = 'TranslateLanguage';
export const FloatingBoxZindex='2147483646' // less than popup
export const PopupZindex= '2147483647'; // max z-index value a element can have
export const StaticRepeater = 'StaticRepeater';
export const StaticRepeaterContent = 'StaticRepeaterContent';
export const StaticRepeaterJSON = 'StaticRepeaterJSON';
export const widgetDataConstant = {
  Text,
  Icon,
  IconButton,
  Image,
  Shapes,
  Line,
  Progress,
  Spacer,
  Card,
  BoundingBox,
  Video,
  Audio,
  Button,
  TextArea,
  DropDown,
  Alert,
  FileInput,
  TextInput,
  RadioButton,
  CheckBox,
  DateAndTime,
  DatePicker,
  Chip,
  Link,
  MenuButton,
  Tabs,
  Container,
  FormContainer,
  Div,
  ModuleChatbot,
  FloatingBox,
  Popup,
  ImageCard,
  Section,
  Row,
  Col,
  Grid,
  Toggle,
  MultiLineInputText,
  Password,
  Url,
  Email,
  InputNumber,
  MultiSelect,
  SingleSelect,
  Iframe,
  Repeator,
  CurrencyInput,
  TimePicker,
  Carousel,
  GoogleMap,
  Ratings,
  Popover,
  CustomisedAccordion,
  Conversation,
  PlaceAutoComplete,
  // PhoneNumberInput,
  InputPhone,
  TextWidgetVersion,
  Table,
  HiddenwidgetEyeIcon,
  SlideBlock,
  SlideBlockShow,
  SlideBlockClose,
  OverlayBackground,
  PropValue,
  ShowSlideBlock,
  CloseSlideBlock,
  SlideBlockZindex,
  SlideBlockCloseButtonZindex,
  TranslateLanguage,
  PopupZindex,
  StaticRepeater,
  StaticRepeaterContent,
  StaticRepeaterJSON
};
